import React from 'react'
import "semantic-ui-css/semantic.min.css"
import {
  Pagination,
} from "semantic-ui-react"

const PaginationComponent = ({
  currentPage = 1,
  onItemsPerPageChange = () => {},
  onPageChange = () => {},
  totalPages = 1,
  itemsPerPage = 25,
  totalTransactions = 0,
} = {}) => {
  const startIndex = (currentPage - 1) * itemsPerPage + 1
  const endIndex = Math.min(
    currentPage * itemsPerPage,
    totalTransactions,
  )
  const nbItemsChoice = [
    10,
    25,
    50,
    100,
  ]

  return (
    <div className="pagination-container">
      <div className="items-per-page-selector">
        <div className="button-group">
          {nbItemsChoice.map(nbItems => (
            <button
              type="button"
              onClick={() => onItemsPerPageChange(nbItems)}
            >
              {`${nbItems}`}
            </button>
          ))}
        </div>
        <span className="label-elements">elements per page</span>
      </div>
      <div className="numberofelements">
        <span>
          {startIndex}
          -
          {endIndex}
          {' '}
          sur
          {' '}
          {totalTransactions}
          {' '}
          elements
        </span>
      </div>
      <Pagination
        className="pagination"
        activePage={currentPage}
        totalPages={totalPages}
        onPageChange={(_, { activePage }) => onPageChange(activePage)}
        siblingRange={1}
        ellipsisItem={{ content: "..." }}
        firstItem={{ content: "First", icon: "angle double left" }}
        lastItem={{ content: "Last", icon: "angle double right" }}
        prevItem={{ content: "Prev", icon: "angle left" }}
        nextItem={{ content: "Next", icon: "angle right" }}
      />
    </div>
  )
}

export default PaginationComponent
